/* Acorn & Pip — Christmas 2026 landing page behaviour */
(function () {
  if (window.__apXmas) return; window.__apXmas = true;

  // Gift finder tabs
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-x-tab]');
    if (!tab) return;
    var root = tab.closest('[data-x-tabs-root]');
    root.querySelectorAll('[data-x-tab]').forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
    root.querySelectorAll('[data-x-panel]').forEach(function (p) { p.hidden = p.id !== tab.getAttribute('aria-controls'); });
    tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  });
  // Deep link e.g. #guide-toddler
  if (location.hash) {
    var t = document.querySelector('[data-x-tab][data-x-slug="' + location.hash.slice(1) + '"]');
    if (t) t.click();
  }

  // Quick add to basket
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-x-add]');
    if (!btn) return;
    e.preventDefault();
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding…';
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-x-add')), quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw r; return fetch('/cart.js').then(function (c) { return c.json(); }); })
      .then(function (cart) {
        btn.classList.add('is-added'); btn.textContent = 'Added ✓';
        document.querySelectorAll('.cart-count, .cart-count-bubble span, [data-cart-count], .header__cart-count').forEach(function (el) { el.textContent = cart.item_count; });
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        setTimeout(function () { btn.textContent = label; btn.classList.remove('is-added'); btn.disabled = false; }, 2200);
      })
      .catch(function () { btn.textContent = 'Sorry, try again'; btn.disabled = false; });
  });

  // Countdown to last order date
  document.querySelectorAll('[data-x-countdown]').forEach(function (el) {
    var end = new Date(el.getAttribute('data-x-countdown') + 'T23:59:00');
    var days = Math.ceil((end - new Date()) / 86400000);
    var n = el.querySelector('strong');
    if (isNaN(days) || days < 0) { el.hidden = true; return; }
    n.textContent = days;
    if (days === 1) { var u = el.querySelector('[data-x-unit]'); if (u) u.textContent = 'day'; }
  });

  // Sticky mobile CTA once the hero is out of view
  var sticky = document.querySelector('.x-sticky');
  var hero = document.querySelector('.x-hero');
  var guides = document.querySelector('.x-guides');
  if (sticky && hero && 'IntersectionObserver' in window) {
    var heroGone = false, inGuides = false;
    var upd = function () { sticky.classList.toggle('is-visible', heroGone && !inGuides); };
    new IntersectionObserver(function (es) { heroGone = !es[0].isIntersecting; upd(); }).observe(hero);
    if (guides) new IntersectionObserver(function (es) { inGuides = es[0].isIntersecting; upd(); }).observe(guides);
  }
})();
